/**
 * The natural gas display units a user can pick in Preferences (AB#8545).
 * An SPA-only display choice: gas is stored in therms and `$/therm`, and the
 * preference converts at render time, the way the electric pricing unit
 * does for `$/kWh`.
 */
export type GasUnit = "ccf" | "mcf" | "dth" | "therms" | "mmbtu";

/** Every unit, in the order the Preferences picker lists them. */
export const GAS_UNITS: readonly GasUnit[] = ["ccf", "mcf", "dth", "therms", "mmbtu"];

/** How each unit is written beside a value — `12.5 Mcf`, `$5.12/Dth`. */
export const GAS_UNIT_LABELS: Record<GasUnit, string> = {
  ccf: "Ccf",
  mcf: "Mcf",
  dth: "Dth",
  therms: "therms",
  mmbtu: "MMBtu",
};

/** The Preferences picker's option names, as the ticket lists them. */
export const GAS_UNIT_PICKER_LABELS: Record<GasUnit, string> = {
  ccf: "Ccf",
  mcf: "Mcf",
  dth: "Dth",
  therms: "Therms",
  mmbtu: "MMBtu",
};

/**
 * Therms in one of each unit. A Dth and an MMBtu are both one million Btu,
 * ten therms. Ccf and Mcf are volumes; at the 1,038 Btu per cubic foot heat
 * content the app already converts margins with (`margin_uom.rs`), 100 cubic
 * feet is 1.038 therms and 1,000 is 10.38.
 */
export const THERMS_PER_GAS_UNIT: Record<GasUnit, number> = {
  ccf: 1.038,
  mcf: 10.38,
  dth: 10,
  therms: 1,
  mmbtu: 10,
};
